import request from 'utils/request';
import buildQueryParams from 'utils/buildQueryParams';

export const getInvoicePackages = params => request.get('/packages', { params: buildQueryParams(params) });
export const createInvoicePackage = payload => request.post('/packages', payload);
export const updateInvoicePackage = payload => request.put(`/packages/${payload.id}`, payload);
